import { Icons } from "../../ui/icons";

export const games = [
  { label: "Plinko", Icon: Icons.cards, url: "/plinko", image: "./media/home/plinko.jpg" },
  { label: "video poker", Icon: Icons.video_poker, url: "/video-poker", image: "./media/home/video-poker.jpg" },
  { label: "roullete", Icon: Icons.roullete, url: "/roullete", image: "./media/home/roullete.jpg" },
  // { label: "blackjack", Icon: Icons.slot, url: "/blackjack", image: "./media/home/blackjack.jpg" },
  { label: "Slot Machine", Icon: Icons.slot, url: "/slot", image: "./media/home/slot.jpg" },
  { label: "Dice Roller", Icon: Icons.dice, url: "/dice-roller", image: "./media/home/dice-roller.jpg" },
  { label: "Aviator", Icon: Icons.aviator, url: "/aviator", image: "./media/home/aviator.jpg" },
];

export const trending = [
  { label: "", image: "./media/home/trending_1.png" },
  { label: "", image: "./media/home/trending_2.png" },
  { label: "", image: "./media/home/trending_3.png" },
  { label: "", image: "./media/home/trending_4.png" },
  { label: "", image: "./media/home/trending_5.png" },
];
